import React from 'react';
import useEsiPortal from '../../hooks/useEsiPortal';
import styles from './Breadcrumb.module.css';

interface BreadcrumbProps {
  productId: string;
}

// productId is used server-side in productBody.tsx to build the ESI URL;
// the client component only provides a mount point for the relocated ESI content.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Breadcrumb(_props: BreadcrumbProps) {
  const ref = useEsiPortal('esi-breadcrumbs');

  return <div ref={ref} className={styles.breadcrumb__root} />;
}

export default Breadcrumb;
